import { Benefit } from 'features/v2a/receiver/screens/PaymentsConfirmation/PaymentsConfirmation';
import React from 'react';
import { View } from 'react-native';
import HairLineDivider from 'shared/components/vxl/divider/HairlineDivider/HairLineDivider';
import ListItem from 'shared/components/vxl/ListItem/ListItem';
import { VXLComponentId } from 'shared/renderer/types';

interface BenefitItemProps {
  item: Benefit;
  showHairline: boolean;
}

const BenefitItem = ({ item, showHairline }: BenefitItemProps) => (
  <View>
    <ListItem
      primaryCopy={item.title}
      leadingAccessory={{
        id: item.icon,
        name: VXLComponentId.ICON,
        props: { iconKey: item.icon },
      }}
      showsChevron={false}
    />
    {showHairline ? <HairLineDivider /> : null}
  </View>
);

export default BenefitItem;
